import { gql } from 'apollo-angular';
import { UserStorageFragment } from '@shared/graphql/fragments/user-storage.fragment';

export const RegisterDocument = gql`
  mutation register($input: RegisterInputGraphql!) {
    register(input: $input) {
      token
      eventType
      user {
        ...UserStorage
      }
    }
  }
  ${UserStorageFragment}
`;
